import src from "IMAGE";
export default { src, width: 285, height: 41, blurWidth: 0, blurHeight: 0};
